import { render, staticRenderFns } from "./ActiveVehicles.vue?vue&type=template&id=1946b680&scoped=true"
import script from "./ActiveVehicles.vue?vue&type=script&lang=js"
export * from "./ActiveVehicles.vue?vue&type=script&lang=js"
import style0 from "./ActiveVehicles.vue?vue&type=style&index=0&id=1946b680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1946b680",
  null
  
)

export default component.exports